import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('GameList').create(({ theme }) => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '12px',
  },

  listItem: {
    margin: '0',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: '#2e3034',
    borderRadius: '8px',
    height: '80px',
    border: '1px solid',
    borderColor: 'rgba(255, 255, 255, 0.10)',
  },

  gameInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '12px',
  },
  gameIcon: {
    width: '120px',
    height: '72px',
    padding: '4px',
    img: {
      width: '100%',
      height: '100%',
      borderRadius: '8px',
      objectFit: 'fill',
    },
  },

  gameTitleAndHoursWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  gameTitle: {
    color: theme.colors.text.primary,
    fontWeight: '450',
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'Inter',
  },

  hours: {
    color: theme.colors.text.secondary,
    fontWeight: '450',
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'Inter',
  },

  gameTime: {
    paddingRight: '12px',
    display: 'flex',
    fontSize: '13px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'end',
    color: theme.colors.text.secondary,
    width: '20%',
  },
}))
